.eds-footer {
  padding: var(--eds--padding-16);
}
